"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ResultCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Cards = require("./Cards");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var DEFAULT_CARD_MAP = {
  subject: _Cards.CaseCard,
  sample: _Cards.SampleCard,
  study: _Cards.StudyCard,
  file: _Cards.FileCard,
  program: _Cards.ProgramCard,
  node: _Cards.ValueCard,
  value: _Cards.ValueCard,
  property: _Cards.ValueCard,
  about: _Cards.AboutCard
};

/**
 * This is a helper component to wrap the Search Result Card components
 *
 * Note: If the component type is unknown,
 * a placeholder component will be rendered instead
 *
 * @param {object} props
 * @param {string} props.searchText - The search text entered by the user
 * @param {object} props.data - The data object used to render the component
 * @param {object} props.classes - The classes object used to style the component
 * @param {number} props.index - The index of the data object in the search results
 * @param {object} [props.resultMap] - The mapping of search result types to components
 * @returns {JSX.Element} - The component to render
 */
var ResultCard = function ResultCard(props) {
  var searchText = props.searchText,
    data = props.data,
    classes = props.classes,
    index = props.index,
    resultMap = props.resultMap; // Use the provided cardMap if it exists
  if (resultMap && typeof resultMap[data.type] !== 'undefined') {
    return /*#__PURE__*/(0, _react.createElement)(resultMap[data.type], {
      data: data,
      classes: classes,
      index: index,
      searchText: searchText
    });
  }

  // Default to the default card map
  if (typeof DEFAULT_CARD_MAP[data.type] !== 'undefined') {
    return /*#__PURE__*/(0, _react.createElement)(DEFAULT_CARD_MAP[data.type], {
      data: data,
      classes: classes,
      index: index,
      searchText: searchText
    });
  }

  // Render a placeholder component
  return /*#__PURE__*/(0, _react.createElement)(function () {
    return /*#__PURE__*/_react.default.createElement("div", null, "The component for ".concat(data.type, " was not found."));
  });
};
exports.ResultCard = ResultCard;
var _default = ResultCard;
exports.default = _default;